<template>
  <div>
    <b-tabs horizontal pills fill v-model="activeTab">
      <b-tab title="Overview">
        <training-overview v-if="activeTab == 0" />
      </b-tab>
      <b-tab title="Participation">
        <training-participation v-if="activeTab == 1" />
      </b-tab>
      <b-tab title="Trends">
        <training-trends v-if="activeTab == 2" />
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import TrainingOverview from './TrainingOverview.vue'
import TrainingParticipation from './TrainingParticipation.vue'
import TrainingTrends from './TrainingTrends.vue'

export default {
  components: {
    TrainingOverview,
    TrainingParticipation,
    TrainingTrends,
  },

  mounted() {},

  data() {
    return {
      activeTab: 0,
    };
  },

  methods: {},
};
</script>
